import * as React from 'react';

import { useIntl } from 'react-intl';

import DonutWithBite from 'components/icons/donut-with-bite';

import { BodyText, HeadingText, IconWrapper, Wrapper } from './offers-empty-state.styled';

/**
 * This component is rendered when the user has no offers on the TH app at the `/offers` path
 */
const OffersEmptyState = () => {
  const { formatMessage } = useIntl();
  return (
    <Wrapper data-testid="th-empty-offers">
      <IconWrapper>
        <DonutWithBite data-testid="empty-offers-icon" />
      </IconWrapper>
      <HeadingText data-testid="empty-offers-heading">
        {formatMessage({ id: 'pleaseTryAgainLater' })}
      </HeadingText>
      <BodyText data-testid="empty-offers-body-text">
        {formatMessage({ id: 'offersEmptyStateText' })}
      </BodyText>
    </Wrapper>
  );
};

export default OffersEmptyState;
